import React, { useEffect, useState } from "react";
import axios from "axios";

import MessageList from "./MessageList";
import classes from "./LLM.module.css";
import { Checkbox } from "@mui/material";
import {
  TbArrowsDiagonal,
  TbArrowsDiagonalMinimize2,
  TbRefresh,
} from "react-icons/tb";
import api from "../../BrandOnBoarding/api";
const LLM = ({ llm, onMessage, setMessageList }) => {
  const [loading, setLoading] = useState(false);
  const [isFullscreen, setisFullscreen] = useState(false);

  async function getLLMResponse() {
    let payload = "";
    if (llm.model === "gpt-4o") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages,
          temperature: 0.1,
          max_tokens: 8000,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          model: "gpt-4o",
        },
      };
    }
    if (llm.model === "gpt-4o-web-search") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages,
          model: "gpt-4o-search-preview",
          max_tokens: 10000,
          // web_search_options: {
          //   user_location: {
          //     type: "approximate",
          //     approximate: {
          //       country: ISO_LOCATION_MAPPING?.[location] || "",
          //       city: "",
          //       region: market || "",
          //     },
          //   },
          // },
        },
      };
    }

    if (llm.model === "gpt-5") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages,
          temperature: 1,
          max_completion_tokens: 8000,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          model: "gpt-5",
          reasoning_effort: "minimal"
        },
      };
    }

    if (llm.model === "gpt-5-search-enabled") {
      
      const cleanMessages = llm.messages.map(msg => ({
        role: msg.role,
        content: msg.content
      }));

      payload = {
        llm: llm.model,
        payload: {
          input: cleanMessages,
          model: "gpt-5",
          text: { verbosity: "low" },
          tool_choice: "auto",
          max_tool_calls: 1,
          parallel_tool_calls: true,
          max_output_tokens: 5000,
          tools: [
            {
              type: "web_search_preview",
              search_context_size: "low",
            },
          ],
        }
      };
    }

    if (llm.model === "gpt-5.2") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages,
          temperature: 1,
          max_completion_tokens: 8000,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          model: "gpt-5.2",
          reasoning_effort: "none"
        },
      };
    }

    if (llm.model === "gpt-5.2-search-enabled") {

      const cleanMessages = llm.messages.map(msg => ({
        role: msg.role,
        content: msg.content
      }));

      payload = {
        llm: llm.model,
        payload: {
          input: cleanMessages,
          model: "gpt-5.2",
          text: { verbosity: "low" },
          tool_choice: "auto",
          max_tool_calls: 1,
          parallel_tool_calls: false,
          max_output_tokens: 5000,
          tools: [
            {
              type: "web_search_preview",
              search_context_size: "low",
            },
          ],
        }
      };
    }

    if (llm.model === "gpt-5.1-chat") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages,
          temperature: 1,
          max_completion_tokens: 8000,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          model: "gpt-5.1-chat-latest",
        },
      };
    }

    if (llm.model === "gpt-5.1-chat-search-enabled") {
      const cleanMessages = llm.messages.map(msg => ({
        role: msg.role,
        content: msg.content
      }));
      payload = {
        llm: llm.model,

        payload: {
          input: cleanMessages,
          model: "gpt-5.1-chat-latest",
          text: { verbosity: "medium" },
          max_output_tokens: 8000,
          tool_choice: "auto",
          max_tool_calls: 1,
          parallel_tool_calls: true,
          tools: [
            {
              type: "web_search_preview",
              search_context_size: "low",
            },
          ],
        }
      }
    }

    if (llm.model === "Claude4") {
      payload = {
        llm: llm.model,
        payload: {
          model: "claude-sonnet-4-20250514",
          max_tokens: 5000,
          temperature: 0.1,
          messages: llm.messages.map((message) => ({
            role: message.role,
            content: message.content,
          })),
        },
      };
    }

    if (llm.model === "Claude-4.5-Search") {
      const claudeMessages = llm.messages.map((message) => ({
        role: message.role,
        content: message.content,
      }));

      payload = {
        llm: llm.model,
        payload: {
          model: "claude-sonnet-4-20250514",
          max_tokens: 5000,
          temperature: 1,
          messages: claudeMessages,
        },
      };
    }

    if (llm.model === "Claude-4.5") {
      payload = {
        llm: llm.model,
        payload: {
          model: "claude-sonnet-4-5-20250929",
          max_tokens: 5000,
          temperature: 0.1,
          messages: llm.messages.map((message) => ({
            role: message.role,
            content: message.content,
          })),
        },
      };
    }

    if (llm.model === "Perplexity") {
      payload = {
        llm: llm.model,
        payload: {
          model: "sonar",
          messages: llm.messages,
          max_tokens: 5000,
          temperature: 0.1,
        },
      };
    }
    if (llm.model === "GeminiV25") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages.slice(1, -1).map((msg) => {
            return {
              role: msg.role === "assistant" ? "model" : "user",
              parts: [
                {
                  text: msg.content,
                },
              ],
            };
          }),
          prompt: llm.messages.slice(-1)[0].content,
          temperature: 0.1,
        },
      };
    }
        if (llm.model === "GeminiV25Search") {
              const lastUser = llm.messages.slice(-1)[0]?.content || "";
            const history = llm.messages
                .slice(1, -1) // drop the initial greeting and the last user msg
                .map((msg) => ({
 role: msg.role === "assistant" ? "model" : "user",
                    parts: [{ text: msg.content }],
                  }));
    
            payload = {
              llm: llm.model, // "GeminiV25Search"
                payload: {
                  prompt: lastUser,
                    messages: history,
                      temperature: 0.1,
                        // model is optional, backend fixes it to "gemini-2.5-flash"
                      },
            };
        }
    if (llm.model === "Gemini-3.0") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages.slice(1, -1).map((msg) => {
            return {
              role: msg.role === "assistant" ? "model" : "user",
              parts: [
                {
                  text: msg.content,
                },
              ],
            };
          }),
          prompt: llm.messages.slice(-1)[0].content,
          temperature: 0.1,
        },
      };
    }
    if (llm.model === "Gemini-3.0-Search") {
      const lastUser = llm.messages.slice(-1)[0]?.content || "";
      const history = llm.messages
        .slice(1, -1) // drop the initial greeting and the last user msg
        .map((msg) => ({
          role: msg.role === "assistant" ? "model" : "user",
          parts: [{ text: msg.content }],
        }));

      payload = {
        llm: llm.model, // "GeminiV25Search"
        payload: {
          prompt: lastUser,
          messages: history,
          temperature: 0.1,
          // model is optional, backend fixes it to "gemini-2.5-flash"
        },
      };
    }
    if (llm.model === "grok-4-1") {
      payload = {
        llm: llm.model,
        payload: {
          messages: llm.messages.map((message) => ({
            role: message.role,
            content: message.content,
          })),
          model: "grok-4-1-fast-non-reasoning"
        },
      };
    }
    if (llm.model === "grok-4-1-web-search") {
      payload = {
        llm: llm.model,
        payload: {
          input: llm.messages.map((message) => ({
            role: message.role,
            content: message.content,
          })),
          model: "grok-4-1-fast-non-reasoning",
          tools: [
            {
              type: "web_search",
            },
          ],
          max_output_tokens: 6000,
          parallel_tool_calls: false,
          temperature: 0.9,
        },
      };
    }
    if (llm.model === "llama3") {
      payload = {
        llm: llm.model,
        payload: {
          messages: [
            {
              role: "user",
              content: llm.messages.slice(-1)[0].content,
            },
          ],
          temperature: 0.1,
        },
      };
    }

    if (llm.model === "deepseek_together") {
      payload = {
        llm: llm.model,
        payload: {
          messages: [
            {
              role: "user",
              content: llm.messages.slice(-1)[0].content,
            },
          ],
          temperature: 0.1,
          max_tokens: 5000,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          model: "deepseek-ai/DeepSeek-V3.1"
        },
      };
    }

    try {
      setLoading(true);
      const response = await api.post("/v2/llm-execute", payload);

      onMessage(llm.name, {
        content: response.data.data,
        id: crypto.randomUUID(),
        role: "assistant",
      });
    } catch (error) {
      console.log(error);
      onMessage(llm.name, {
        content: `Error: ${error?.message || "Something went wrong"}`,
        id: crypto.randomUUID(),
        role: "assistant",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (llm.messages.length === 0) return;
    const lastMessage = llm.messages[llm.messages.length - 1];
    if (lastMessage.role === "user" && lastMessage.content != "") {
      getLLMResponse();
    }
  }, [llm.messages.length]);

  const retry = () => {
    if (llm.isActive) {
      if (llm.messages.length < 2) return;
      setMessageList((prev) =>
        prev.map((eachLlm) =>
          eachLlm.name === llm.name
            ? { ...eachLlm, messages: eachLlm.messages.slice(0, -1) }
            : eachLlm
        )
      );
    }
  };

  function handleChange(event) {
    setMessageList((prev) =>
      prev.map((eachLlm) =>
        eachLlm.name === llm.name
          ? { ...eachLlm, isActive: event.target.checked }
          : eachLlm
      )
    );
  }

  return (
    <div
      className={`${isFullscreen ? classes.chat_full : classes.chat} ${!llm?.isActive ? classes.disabled : ""
        }`}
    >
      <div className={classes.header}>
        <div className={classes.heading}>
          <img className={classes.img} src={llm.img} />
          <span className={classes.name}>{llm.name}</span>
        </div>
        <div>
          <span className={classes.minMax} onClick={retry}>
            <TbRefresh size={20} color="grey" />
          </span>
          <Checkbox
            onChange={handleChange}
            checked={llm?.isActive}
            color="primary"
            sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
          />
          {isFullscreen ? (
            <span
              className={classes.minMax}
              onClick={() => setisFullscreen(false)}
            >
              <TbArrowsDiagonalMinimize2 size={20} color="grey" />
            </span>
          ) : (
            <span
              className={classes.minMax}
              onClick={() => setisFullscreen(true)}
            >
              <TbArrowsDiagonal size={20} color="grey" />
            </span>
          )}
        </div>
      </div>
      <div className={classes.chat_content}>
        <MessageList messages={llm.messages} loading={loading} />
      </div>
    </div>
  );
};

export default LLM;
